module.exports = __webpack_public_path__ + "img/activity5.11dd49e0.png";